import {
  ServiceRequestFieldType,
  ServiceRequestStep,
  ServiceRequestStepType,
} from "@domain/types";

export const contactStep: ServiceRequestStep = {
  type: ServiceRequestStepType.CONTACT,
  inSummary: true,
  title: `quote:contact.title`,
  additionalCopy: `quote:contact.title`,
  segmentEvent: `Contact Filled in`,
  fields: [
    {
      type: ServiceRequestFieldType.INPUT,
      summaryTitle: `form:placeholder.firstName`,
      props: {
        name: `project.user.first_name`,
        label: `quote:contact.firstName.label`,
        type: `text`,
        // placeholder: `form:placeholder.firstName`,
        regex: `/^([^0-9]*)$/`,
        validation: [`isRequired`],
      },
    },
    {
      type: ServiceRequestFieldType.INPUT,
      summaryTitle: `form:placeholder.lastName`,
      props: {
        name: `project.user.last_name`,
        label: `quote:contact.lastName.label`,
        type: `text`,
        // placeholder: `form:placeholder.lastName`,
        regex: `/^([^0-9]*)$/`,
        validation: [`isRequired`],
      },
    },
    {
      type: ServiceRequestFieldType.INPUT,
      summaryTitle: `form:placeholder.phone`,
      props: {
        name: `project.user.phone`,
        type: `text`,
        // placeholder: `quote:phone.phone.placeholder`,
        label: `quote:contact.phone.label`,
        validation: [`isRequired`],
      },
    },
    {
      type: ServiceRequestFieldType.INPUT,
      summaryTitle: `form:placeholder.email`,
      props: {
        name: `project.user.email`,
        // placeholder: `form:placeholder.email`,
        label: `quote:contact.email.label`,
        type: `email`,
        validation: [`isRequired`, `isEmail`],
      },
    },
  ],
};
